import { FC, ReactNode } from 'react';
import { Root } from './styled';

type Props = {
  children?: ReactNode;
};

const EditDesired: FC<Props> = ({ children }) => {
  return <Root>{children}</Root>;
};

export default EditDesired;
